import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

// Catch-all (P1.3): a mistyped or stale link used to render a blank white page with no
// way back. This tells the user what happened and offers the one safe next step.
export default function NotFound() {
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-[#F9FAFB] px-6"
            data-testid="not-found-page"
        >
            <div className="w-full max-w-md text-center">
                <Compass size={28} className="mx-auto text-slate-400" />
                <h1 className="font-heading text-2xl font-bold text-slate-900 mt-4">
                    This page isn't here
                </h1>
                <p className="text-sm text-slate-600 mt-2">
                    The link may be out of date or mistyped. Nothing is lost — your estate's records
                    are exactly where you left them.
                </p>
                <Link
                    to="/"
                    className="inline-block mt-6 rounded-md bg-slate-900 hover:bg-slate-800 text-white text-sm px-5 h-10 leading-10"
                    data-testid="not-found-home-link"
                >
                    Back to the dashboard
                </Link>
            </div>
        </div>
    );
}
